import React from 'react';
import { FiMapPin, FiSmartphone } from 'react-icons/fi';

const PincodeUnavailableState = ({ pincode, message, downloadAppUrl, isDarkMode, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-12 text-center">
      <div className="flex items-center justify-center w-20 h-20 mb-6 bg-orange-100 rounded-full">
        <FiMapPin size={40} className="text-orange-500" />
      </div>
      <h3 className={`text-xl font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
        Service Not Available Yet
      </h3>
      <p className={`text-sm mb-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
        Pickup is currently unavailable for PIN code <span className="font-semibold text-orange-500">{pincode}</span>.
      </p>
      <p className={`text-xs mb-6 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
        {message || 'Please try another PIN code. Service coverage may vary by campaign and location.'}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <button
          type="button"
          onClick={onRetry}
          className="px-6 py-2.5 font-semibold text-white transition-all bg-green-500 rounded-lg hover:bg-green-600"
        >
          Try Different Pincode
        </button>
        {downloadAppUrl && (
          <a
            href={downloadAppUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-lg border border-green-500 px-5 py-2.5 font-semibold text-green-600 hover:bg-green-50"
          >
            <FiSmartphone size={17} /> Download Tap2Cash App
          </a>
        )}
      </div>
      {downloadAppUrl && (
        <p className={`mt-4 text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
          You can explore the app, but downloading it does not guarantee pickup availability.
        </p>
      )}
    </div>
  );
};

export default PincodeUnavailableState;